

import { Component, Vue, Prop } from "vue-property-decorator";
import { Question } from "survey-vue";
import * as UsStatesList from "./UsStatesList.json";
import * as CaProvinceList from "./CaProvinceList.json";
import * as countryList from "./countries.json";
import * as SurveyVue from "survey-vue"; 

@Component
export default class AddressInfo extends Vue {
    
    @Prop({ required: true })
    question!: Question;

    provinceOptions = [];
    USAregionOptions = [];
    CAregionOptions = [];
    countryOptions = [];
    postcodePlaceholder = 'A1A 1A1';
    displayProvinceInputField = false;    

    selOptions = [];
    pendingValue = this.loadValue(this.question.value);

    value = this.question.value;
    copiedAddress = {} as {
        street: any;
        city: any;
        state: any;
        country: any;
        postcode: any;
    };

    mounted() {

        this.USAregionOptions = UsStatesList.states;
        this.CAregionOptions = CaProvinceList.provinces;
        this.countryOptions = countryList.countries;        

        const q = this.question;
        q.valueChangedCallback = () => {
            const pending = this.loadValue(q.value);
            this.pendingValue = pending;
            this.value = q.value;
            this.selOptions = this.prevAddrOptions();
        };
        this.selOptions = this.prevAddrOptions();
        this.displayProvinceInputField = false;

        if (this.value){
            if (this.value.country == "United States") {            
                this.provinceOptions = this.USAregionOptions;
                this.postcodePlaceholder = '12345 or 12345-1234'
            } else if (this.value.country == "Canada") {
                this.provinceOptions = this.CAregionOptions;
                this.postcodePlaceholder = 'A1A 1A1'
            } else {
                this.displayProvinceInputField = true;
                this.provinceOptions = [];
                this.postcodePlaceholder = '';            
            }
        } else {            
            this.provinceOptions = this.CAregionOptions;
            this.pendingValue['country'] = "Canada";
            this.pendingValue['state'] = "BC";
            this.postcodePlaceholder = 'A1A 1A1';          
        }        

        this.questionValidator();
    }

    public questionValidator(){
        this.question.validateValueCallback = () => {
            
            let error = null 
            const address =  Object.assign({}, this.pendingValue);    
            
            if(address?.country =='United States'){
                const index = this.USAregionOptions.findIndex(state=>{return(state.value == address.state)});
                if(index<0)
                    error = new SurveyVue.SurveyError("Please select a 'Province / State / Region'")
                
                if(address.postcode){
                    const postcodeFormat = /(^\d{5}?$)|(^\d{5}\-\d{4}?$)/;                                
                    if(!postcodeFormat.test(address.postcode)) error = new SurveyVue.SurveyError("Postal Code is invalid!")
                }
            }
            else if(address?.country =='Canada'){
                const index = this.CAregionOptions.findIndex(state=>{return(state.value == address.state)});
                if(index<0)
                    error = new SurveyVue.SurveyError("Please select a 'Province / State / Region'")
                
                if(address.postcode){
                    const postcodeFormat = /^[A-Z]\d[A-Z] \d[A-Z]\d?$/;                              
                    if(!postcodeFormat.test(address.postcode)) error = new SurveyVue.SurveyError("Postal Code is invalid!")
                    if(address.postcode?.substring(0,3) == 'A1A' && address.state != 'NL') error = new SurveyVue.SurveyError("Postal Code is invalid for the Province!")
                    if(address.postcode.length != 7 ) error = new SurveyVue.SurveyError("Postal Code is invalid!")
                    
                }
            }
            else {
                
                if(!address.state || address.state.length == 0)
                    error = new SurveyVue.SurveyError("Please select a 'Province / State / Region'")
                
                if(!address.postcode || address.postcode.length == 0)
                    error = new SurveyVue.SurveyError("Please enter the Postal Code!")                    
                
            }

            return error
        }
    }

    public prevAddrOptions() {
        const q = this.question;
        const skipName = q.name;
        const survey = q.survey;
        const addrs = [];
        const seen = {};
        let otherQVal;
        for (const page of survey.pages) {
            for (const otherQ of page["questions"]) {
                
                if ( otherQ.getType() === "address" && otherQ.name !== skipName && (otherQVal = otherQ.value) ) {
                    const parts = [
                        otherQVal.street,
                        otherQVal.city,
                        otherQVal.state,
                        otherQVal.country,
                        otherQVal.postcode
                    ];

                    const lbl = parts
                        .map(p => p.trim())
                        .filter(p => p)
                        .join(", ");

                    if (lbl && !seen[lbl]) {
                        seen[lbl] = 1;
                        addrs.push({
                            name: otherQ.name,
                            label: lbl, // otherQ.referLabel,
                            value: Object.assign({}, otherQ.value)
                        });
                    }
                }
            }
        }
        addrs.sort((a, b) => a.label.localeCompare(b.label));
        return addrs;
    }

    public UpdateRegion() {
        // console.log(this.pendingValue)
        if (this.pendingValue.country == "United States") {
            this.displayProvinceInputField = false;
            this.provinceOptions = this.USAregionOptions;
            this.postcodePlaceholder = '12345 or 12345-1234'
        } else if (this.pendingValue.country == "Canada") {
            this.displayProvinceInputField = false;
            this.provinceOptions = this.CAregionOptions;
            this.postcodePlaceholder = 'A1A 1A1'
        } else {
            this.displayProvinceInputField = true;
            this.provinceOptions = [];
            this.postcodePlaceholder = '';
        }
    }
    
    public updateValue() {

        this.UpdateRegion();

        const value = Object.assign({}, this.pendingValue);
        for (const k in value) {
            if (value[k] !== undefined && value[k].length) {
                this.question.value = value;
                return;
            }
        }
        this.question.value = null;
    }

    public loadValue(val) {
        val = val || {};

        return {
            street: val.street || "",
            city: val.city || "",
            state: val.state || "",
            country: val.country || "",
            postcode: val.postcode || ""
        };       
    }

    public copySelected() {       
        this.pendingValue = this.copiedAddress;
        this.updateValue();
    }
}
